export default function appendStyle(id, css) {
  if (!document.head.querySelector('#' + id)) {
    var node = document.createElement('style');
    node.textContent = css;
    node.type = 'text/css';
    node.id = id;

    document.head.appendChild(node);
  }
}


//////////////////
// WEBPACK FOOTER
// ../component-library/node_modules/react-css-component/es/utils/appendStyle.js
// module id = 363
// module chunks = 0